module.exports = __webpack_public_path__ + "img/portlands.147b4f5b.png";